import { E as se, e as ae } from "./ElementResolution-BiRkFPHH.js";
import { r as re } from "./random-id-aENvrLj2.js";
import { A as jt, n as M, g as vt, o as at, s as le } from "./strategies-BOoCrCJR.js";
import { L as Ge } from "./strategies-BOoCrCJR.js";
import { f as wt, a as bt } from "./first-focusable-in-B2hcE1GI.js";
import { u as xt } from "./focusable-selectors-BDDc1rUp.js";
import { S as ce, r as he } from "./slottable-request-event-B1mW6PN4.js";
import { i as pe, x as rt } from "./lit-element-6iugfgmM.js";
import { n as N } from "./property-BWlAHqg_.js";
import { i as $t } from "./query-D8_rwLua.js";
import { l as de } from "./query-assigned-elements-B8U94KLQ.js";
import { t as ue } from "./state-STZTbIJp.js";
import { o as mt } from "./if-defined-D-RhGngI.js";
import { o as Bt } from "./style-map-DBc4Yfgo.js";
class pt {
  constructor(t, n) {
    this.x = 0, this.y = 0, this.x = t, this.y = n;
  }
  updateBoundingClientRect(t, n) {
    this.x = t, this.y = n, jt.update();
  }
  getBoundingClientRect() {
    return { width: 0, height: 0, top: this.y, right: this.x, y: this.y, x: this.x, bottom: this.y, left: this.x, toJSON() {
    } };
  }
}
class Et extends Event {
  constructor() {
    super("beforetoggle", { bubbles: !1, composed: !1 }), this.currentState = "open", this.newState = "closed";
  }
}
class Pt extends Event {
  constructor() {
    super("beforetoggle", { bubbles: !1, composed: !1 }), this.currentState = "closed", this.newState = "open";
  }
}
class W extends Event {
  constructor(t, n, { publish: o, interaction: s, reason: i }) {
    super(t, { bubbles: o, composed: o }), this.overlay = n, this.detail = { interaction: s, reason: i };
  }
}
const ge = CSS.supports("(overlay: auto)");
function Ht(e) {
  let t = !1;
  try {
    t = e.matches(":popover-open");
  } catch {
  }
  let n = !1;
  try {
    n = e.matches(":open");
  } catch {
  }
  return t || n;
}
const fe = "showPopover" in document.createElement("div"), Mt = new class {
  constructor() {
    this.root = document.body, this.stack = [], this.handlePointerdown = (e) => {
      this.pointerdownPath = e.composedPath(), this.lastOverlay = this.stack[this.stack.length - 1];
    }, this.handlePointerup = () => {
      const e = this.pointerdownPath;
      if (this.pointerdownPath = void 0, !this.stack.length || e == null || !e.length) return;
      const t = this.lastOverlay;
      this.lastOverlay = void 0;
      const n = this.stack.length - 1, o = this.stack.filter((s, i) => !(e.find((a) => a === s || a === (s == null ? void 0 : s.triggerElement) && (s == null ? void 0 : s.type) === "hint" || i === n && s !== t && s.triggerInteraction === "longpress") || s.shouldPreventClose() || s.type === "manual" || s.type === "modal" && t !== s));
      o.reverse(), o.forEach((s) => {
        this.closeOverlay(s);
        let i = s.parentOverlayToForceClose;
        for (; i; ) this.closeOverlay(i), i = i.parentOverlayToForceClose;
      });
    }, this.handleBeforetoggle = (e) => {
      const { target: t, newState: n } = e;
      n !== "open" && this.closeOverlay(t);
    }, this.handleKeydown = (e) => {
      if (e.code !== "Escape" || !this.stack.length) return;
      const t = this.stack[this.stack.length - 1];
      (t == null ? void 0 : t.type) !== "page" ? fe || (t == null ? void 0 : t.type) !== "manual" && t && this.closeOverlay(t) : e.preventDefault();
    }, this.bindEvents();
  }
  get document() {
    return this.root.ownerDocument || document;
  }
  bindEvents() {
    this.document.addEventListener("pointerdown", this.handlePointerdown), this.document.addEventListener("pointerup", this.handlePointerup), this.document.addEventListener("keydown", this.handleKeydown);
  }
  closeOverlay(e) {
    const t = this.stack.indexOf(e);
    t > -1 && this.stack.splice(t, 1), e.open = !1;
  }
  overlaysByTriggerElement(e) {
    return this.stack.filter((t) => t.triggerElement === e);
  }
  add(e) {
    if (this.stack.includes(e)) {
      const t = this.stack.indexOf(e);
      t > -1 && (this.stack.splice(t, 1), this.stack.push(e));
    } else {
      if (e.type === "auto" || e.type === "modal" || e.type === "page") {
        const t = "sp-overlay-query-path", n = new Event(t, { composed: !0, bubbles: !0 });
        e.addEventListener(t, (o) => {
          const s = o.composedPath();
          this.stack.forEach((i) => {
            !s.find((a) => a === i) && i.type !== "manual" && i.type !== "modal" && this.closeOverlay(i);
          });
        }, { once: !0 }), e.dispatchEvent(n);
      } else if (e.type === "hint") {
        if (this.stack.some((t) => t.type !== "manual" && t.triggerElement && t.triggerElement === e.triggerElement)) return void (e.open = !1);
        this.stack.forEach((t) => {
          t.type === "hint" && this.closeOverlay(t);
        });
      }
      requestAnimationFrame(() => {
        this.stack.push(e), e.addEventListener("beforetoggle", this.handleBeforetoggle, { once: !0 });
      });
    }
  }
  remove(e) {
    this.closeOverlay(e);
  }
}(), X = Math.min, B = Math.max, dt = Math.round, lt = Math.floor, Y = (e) => ({ x: e, y: e }), me = { left: "right", right: "left", bottom: "top", top: "bottom" }, ye = { start: "end", end: "start" };
function Ot(e, t, n) {
  return B(e, X(t, n));
}
function et(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function K(e) {
  return e.split("-")[0];
}
function Z(e) {
  return e.split("-")[1];
}
function Kt(e) {
  return e === "x" ? "y" : "x";
}
function St(e) {
  return e === "y" ? "height" : "width";
}
function st(e) {
  return ["top", "bottom"].includes(K(e)) ? "y" : "x";
}
function Lt(e) {
  return Kt(st(e));
}
function yt(e) {
  return e.replace(/start|end/g, (t) => ye[t]);
}
function ct(e) {
  return e.replace(/left|right|bottom|top/g, (t) => me[t]);
}
function Xt(e) {
  return typeof e != "number" ? function(t) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t };
  }(e) : { top: e, right: e, bottom: e, left: e };
}
function ut(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
function qt(e, t, n) {
  let { reference: o, floating: s } = e;
  const i = st(t), a = Lt(t), l = St(a), r = K(t), c = i === "y", g = o.x + o.width / 2 - s.width / 2, m = o.y + o.height / 2 - s.height / 2, d = o[l] / 2 - s[l] / 2;
  let p;
  switch (r) {
    case "top":
      p = { x: g, y: o.y - s.height };
      break;
    case "bottom":
      p = { x: g, y: o.y + o.height };
      break;
    case "right":
      p = { x: o.x + o.width, y: m };
      break;
    case "left":
      p = { x: o.x - s.width, y: m };
      break;
    default:
      p = { x: o.x, y: o.y };
  }
  switch (Z(t)) {
    case "start":
      p[a] -= d * (n && c ? -1 : 1);
      break;
    case "end":
      p[a] += d * (n && c ? -1 : 1);
  }
  return p;
}
async function Tt(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: o, y: s, platform: i, rects: a, elements: l, strategy: r } = e, { boundary: c = "clippingAncestors", rootBoundary: g = "viewport", elementContext: m = "floating", altBoundary: d = !1, padding: p = 0 } = et(t, e), h = Xt(p), f = l[d ? m === "floating" ? "reference" : "floating" : m], u = ut(await i.getClippingRect({ element: (n = await (i.isElement == null ? void 0 : i.isElement(f))) == null || n ? f : f.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)), boundary: c, rootBoundary: g, strategy: r })), y = m === "floating" ? { ...a.floating, x: o, y: s } : a.reference, v = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), w = await (i.isElement == null ? void 0 : i.isElement(v)) && await (i.getScale == null ? void 0 : i.getScale(v)) || { x: 1, y: 1 }, x = ut(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({ elements: l, rect: y, offsetParent: v, strategy: r }) : y);
  return { top: (u.top - x.top + h.top) / w.y, bottom: (x.bottom - u.bottom + h.bottom) / w.y, left: (u.left - x.left + h.left) / w.x, right: (x.right - u.right + h.right) / w.x };
}
const ve = function(e) {
  return e === void 0 && (e = 0), { name: "offset", options: e, async fn(t) {
    var n, o;
    const { x: s, y: i, placement: a, middlewareData: l } = t, r = await async function(c, g) {
      const { placement: m, platform: d, elements: p } = c, h = await (d.isRTL == null ? void 0 : d.isRTL(p.floating)), f = K(m), u = Z(m), y = st(m) === "y", v = ["left", "top"].includes(f) ? -1 : 1, w = h && y ? -1 : 1, x = et(g, c);
      let { mainAxis: k, crossAxis: b, alignmentAxis: E } = typeof x == "number" ? { mainAxis: x, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...x };
      return u && typeof E == "number" && (b = u === "end" ? -1 * E : E), y ? { x: b * w, y: k * v } : { x: k * v, y: b * w };
    }(t, e);
    return a === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : { x: s + r.x, y: i + r.y, data: { ...r, placement: a } };
  } };
};
function G(e) {
  return Yt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function H(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function U(e) {
  var t;
  return (t = (Yt(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Yt(e) {
  return e instanceof Node || e instanceof H(e).Node;
}
function z(e) {
  return e instanceof Element || e instanceof H(e).Element;
}
function V(e) {
  return e instanceof HTMLElement || e instanceof H(e).HTMLElement;
}
function Nt(e) {
  return typeof ShadowRoot < "u" && (e instanceof ShadowRoot || e instanceof H(e).ShadowRoot);
}
function it(e) {
  const { overflow: t, overflowX: n, overflowY: o, display: s } = q(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(s);
}
function we(e) {
  return ["table", "td", "th"].includes(G(e));
}
function Ct(e) {
  const t = kt(), n = q(e);
  return n.transform !== "none" || n.perspective !== "none" || !!n.containerType && n.containerType !== "normal" || !t && !!n.backdropFilter && n.backdropFilter !== "none" || !t && !!n.filter && n.filter !== "none" || ["transform", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function kt() {
  return !(typeof CSS > "u" || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function gt(e) {
  return ["html", "body", "#document"].includes(G(e));
}
function q(e) {
  return H(e).getComputedStyle(e);
}
function ft(e) {
  return z(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function tt(e) {
  if (G(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || Nt(e) && e.host || U(e);
  return Nt(t) ? t.host : t;
}
function Gt(e) {
  const t = tt(e);
  return gt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : V(t) && it(t) ? t : Gt(t);
}
function ot(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = Gt(e), i = s === ((o = e.ownerDocument) == null ? void 0 : o.body), a = H(s);
  return i ? t.concat(a, a.visualViewport || [], it(s) ? s : [], a.frameElement && n ? ot(a.frameElement) : []) : t.concat(s, ot(s, [], n));
}
function Jt(e) {
  const t = q(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const s = V(e), i = s ? e.offsetWidth : n, a = s ? e.offsetHeight : o, l = dt(n) !== i || dt(o) !== a;
  return l && (n = i, o = a), { width: n, height: o, $: l };
}
function At(e) {
  return z(e) ? e : e.contextElement;
}
function Q(e) {
  const t = At(e);
  if (!V(t)) return Y(1);
  const n = t.getBoundingClientRect(), { width: o, height: s, $: i } = Jt(t);
  let a = (i ? dt(n.width) : n.width) / o, l = (i ? dt(n.height) : n.height) / s;
  return a && Number.isFinite(a) || (a = 1), l && Number.isFinite(l) || (l = 1), { x: a, y: l };
}
const be = Y(0);
function Qt(e) {
  const t = H(e);
  return kt() && t.visualViewport ? { x: t.visualViewport.offsetLeft, y: t.visualViewport.offsetTop } : be;
}
function J(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), i = At(e);
  let a = Y(1);
  t && (o ? z(o) && (a = Q(o)) : a = Q(e));
  const l = function(d, p, h) {
    return p === void 0 && (p = !1), !(!h || p && h !== H(d)) && p;
  }(i, n, o) ? Qt(i) : Y(0);
  let r = (s.left + l.x) / a.x, c = (s.top + l.y) / a.y, g = s.width / a.x, m = s.height / a.y;
  if (i) {
    const d = H(i), p = o && z(o) ? H(o) : o;
    let h = d, f = h.frameElement;
    for (; f && o && p !== h; ) {
      const u = Q(f), y = f.getBoundingClientRect(), v = q(f), w = y.left + (f.clientLeft + parseFloat(v.paddingLeft)) * u.x, x = y.top + (f.clientTop + parseFloat(v.paddingTop)) * u.y;
      r *= u.x, c *= u.y, g *= u.x, m *= u.y, r += w, c += x, h = H(f), f = h.frameElement;
    }
  }
  return ut({ width: g, height: m, x: r, y: c });
}
const xe = [":popover-open", ":modal"];
function Zt(e) {
  return xe.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function te(e) {
  return J(U(e)).left + ft(e).scrollLeft;
}
function Wt(e, t, n) {
  let o;
  if (t === "viewport") o = function(s, i) {
    const a = H(s), l = U(s), r = a.visualViewport;
    let c = l.clientWidth, g = l.clientHeight, m = 0, d = 0;
    if (r) {
      c = r.width, g = r.height;
      const p = kt();
      (!p || p && i === "fixed") && (m = r.offsetLeft, d = r.offsetTop);
    }
    return { width: c, height: g, x: m, y: d };
  }(e, n);
  else if (t === "document") o = function(s) {
    const i = U(s), a = ft(s), l = s.ownerDocument.body, r = B(i.scrollWidth, i.clientWidth, l.scrollWidth, l.clientWidth), c = B(i.scrollHeight, i.clientHeight, l.scrollHeight, l.clientHeight);
    let g = -a.scrollLeft + te(s);
    const m = -a.scrollTop;
    return q(l).direction === "rtl" && (g += B(i.clientWidth, l.clientWidth) - r), { width: r, height: c, x: g, y: m };
  }(U(e));
  else if (z(t)) o = function(s, i) {
    const a = J(s, !0, i === "fixed"), l = a.top + s.clientTop, r = a.left + s.clientLeft, c = V(s) ? Q(s) : Y(1);
    return { width: s.clientWidth * c.x, height: s.clientHeight * c.y, x: r * c.x, y: l * c.y };
  }(t, n);
  else {
    const s = Qt(e);
    o = { ...t, x: t.x - s.x, y: t.y - s.y };
  }
  return ut(o);
}
function ee(e, t) {
  const n = tt(e);
  return !(n === t || !z(n) || gt(n)) && (q(n).position === "fixed" || ee(n, t));
}
function Ee(e, t, n) {
  const o = V(t), s = U(t), i = n === "fixed", a = J(e, !0, i, t);
  let l = { scrollLeft: 0, scrollTop: 0 };
  const r = Y(0);
  if (o || !o && !i) if ((G(t) !== "body" || it(s)) && (l = ft(t)), o) {
    const c = J(t, !0, i, t);
    r.x = c.x + t.clientLeft, r.y = c.y + t.clientTop;
  } else s && (r.x = te(s));
  return { x: a.left + l.scrollLeft - r.x, y: a.top + l.scrollTop - r.y, width: a.width, height: a.height };
}
function _t(e, t) {
  return V(e) && q(e).position !== "fixed" ? t ? t(e) : e.offsetParent : null;
}
function Vt(e, t) {
  const n = H(e);
  if (!V(e) || Zt(e)) return n;
  let o = _t(e, t);
  for (; o && we(o) && q(o).position === "static"; ) o = _t(o, t);
  return o && (G(o) === "html" || G(o) === "body" && q(o).position === "static" && !Ct(o)) ? n : o || function(s) {
    let i = tt(s);
    for (; V(i) && !gt(i); ) {
      if (Ct(i)) return i;
      i = tt(i);
    }
    return null;
  }(e) || n;
}
const Pe = { convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { elements: t, rect: n, offsetParent: o, strategy: s } = e;
  const i = s === "fixed", a = U(o), l = !!t && Zt(t.floating);
  if (o === a || l && i) return n;
  let r = { scrollLeft: 0, scrollTop: 0 }, c = Y(1);
  const g = Y(0), m = V(o);
  if ((m || !m && !i) && ((G(o) !== "body" || it(a)) && (r = ft(o)), V(o))) {
    const d = J(o);
    c = Q(o), g.x = d.x + o.clientLeft, g.y = d.y + o.clientTop;
  }
  return { width: n.width * c.x, height: n.height * c.y, x: n.x * c.x - r.scrollLeft * c.x + g.x, y: n.y * c.y - r.scrollTop * c.y + g.y };
}, getDocumentElement: U, getClippingRect: function(e) {
  let { element: t, boundary: n, rootBoundary: o, strategy: s } = e;
  const i = [...n === "clippingAncestors" ? function(r, c) {
    const g = c.get(r);
    if (g) return g;
    let m = ot(r, [], !1).filter((f) => z(f) && G(f) !== "body"), d = null;
    const p = q(r).position === "fixed";
    let h = p ? tt(r) : r;
    for (; z(h) && !gt(h); ) {
      const f = q(h), u = Ct(h);
      u || f.position !== "fixed" || (d = null), (p ? !u && !d : !u && f.position === "static" && d && ["absolute", "fixed"].includes(d.position) || it(h) && !u && ee(r, h)) ? m = m.filter((y) => y !== h) : d = f, h = tt(h);
    }
    return c.set(r, m), m;
  }(t, this._c) : [].concat(n), o], a = i[0], l = i.reduce((r, c) => {
    const g = Wt(t, c, s);
    return r.top = B(g.top, r.top), r.right = X(g.right, r.right), r.bottom = X(g.bottom, r.bottom), r.left = B(g.left, r.left), r;
  }, Wt(t, a, s));
  return { width: l.right - l.left, height: l.bottom - l.top, x: l.left, y: l.top };
}, getOffsetParent: Vt, getElementRects: async function(e) {
  const t = this.getOffsetParent || Vt, n = this.getDimensions;
  return { reference: Ee(e.reference, await t(e.floating), e.strategy), floating: { x: 0, y: 0, ...await n(e.floating) } };
}, getClientRects: function(e) {
  return Array.from(e.getClientRects());
}, getDimensions: function(e) {
  const { width: t, height: n } = Jt(e);
  return { width: t, height: n };
}, getScale: Q, isElement: z, isRTL: function(e) {
  return q(e).direction === "rtl";
} };
function Ut(e, t, n, o) {
  o === void 0 && (o = {});
  const { ancestorScroll: s = !0, ancestorResize: i = !0, elementResize: a = typeof ResizeObserver == "function", layoutShift: l = typeof IntersectionObserver == "function", animationFrame: r = !1 } = o, c = At(e), g = s || i ? [...c ? ot(c) : [], ...ot(t)] : [];
  g.forEach((u) => {
    s && u.addEventListener("scroll", n, { passive: !0 }), i && u.addEventListener("resize", n);
  });
  const m = c && l ? function(u, y) {
    let v, w = null;
    const x = U(u);
    function k() {
      var b;
      clearTimeout(v), (b = w) == null || b.disconnect(), w = null;
    }
    return function b(E, L) {
      E === void 0 && (E = !1), L === void 0 && (L = 1), k();
      const { left: $, top: _, width: A, height: O } = u.getBoundingClientRect();
      if (E || y(), !A || !O) return;
      const D = { rootMargin: -lt(_) + "px " + -lt(x.clientWidth - ($ + A)) + "px " + -lt(x.clientHeight - (_ + O)) + "px " + -lt($) + "px", threshold: B(0, X(1, L)) || 1 };
      let C = !0;
      function R(S) {
        const P = S[0].intersectionRatio;
        if (P !== L) {
          if (!C) return b();
          P ? b(!1, P) : v = setTimeout(() => {
            b(!1, 1e-7);
          }, 100);
        }
        C = !1;
      }
      try {
        w = new IntersectionObserver(R, { ...D, root: x.ownerDocument });
      } catch {
        w = new IntersectionObserver(R, D);
      }
      w.observe(u);
    }(!0), k;
  }(c, n) : null;
  let d, p = -1, h = null;
  a && (h = new ResizeObserver((u) => {
    let [y] = u;
    y && y.target === c && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var v;
      (v = h) == null || v.observe(t);
    })), n();
  }), c && !r && h.observe(c), h.observe(t));
  let f = r ? J(e) : null;
  return r && function u() {
    const y = J(e);
    !f || y.x === f.x && y.y === f.y && y.width === f.width && y.height === f.height || n(), f = y, d = requestAnimationFrame(u);
  }(), n(), () => {
    var u;
    g.forEach((y) => {
      s && y.removeEventListener("scroll", n), i && y.removeEventListener("resize", n);
    }), m == null || m(), (u = h) == null || u.disconnect(), h = null, r && cancelAnimationFrame(d);
  };
}
const Oe = function(e) {
  return e === void 0 && (e = {}), { name: "shift", options: e, async fn(t) {
    const { x: n, y: o, placement: s } = t, { mainAxis: i = !0, crossAxis: a = !1, limiter: l = { fn: (u) => {
      let { x: y, y: v } = u;
      return { x: y, y: v };
    } }, ...r } = et(e, t), c = { x: n, y: o }, g = await Tt(t, r), m = st(K(s)), d = Kt(m);
    let p = c[d], h = c[m];
    if (i) {
      const u = d === "y" ? "bottom" : "right";
      p = Ot(p + g[d === "y" ? "top" : "left"], p, p - g[u]);
    }
    if (a) {
      const u = m === "y" ? "bottom" : "right";
      h = Ot(h + g[m === "y" ? "top" : "left"], h, h - g[u]);
    }
    const f = l.fn({ ...t, [d]: p, [m]: h });
    return { ...f, data: { x: f.x - n, y: f.y - o } };
  } };
}, zt = function(e) {
  return e === void 0 && (e = {}), { name: "flip", options: e, async fn(t) {
    var n, o;
    const { placement: s, middlewareData: i, rects: a, initialPlacement: l, platform: r, elements: c } = t, { mainAxis: g = !0, crossAxis: m = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: h = "none", flipAlignment: f = !0, ...u } = et(e, t);
    if ((n = i.arrow) != null && n.alignmentOffset) return {};
    const y = K(s), v = K(l) === l, w = await (r.isRTL == null ? void 0 : r.isRTL(c.floating)), x = d || (v || !f ? [ct(l)] : function(O) {
      const D = ct(O);
      return [yt(O), D, yt(D)];
    }(l));
    d || h === "none" || x.push(...function(O, D, C, R) {
      const S = Z(O);
      let P = function(I, j, ne) {
        const Dt = ["left", "right"], Ft = ["right", "left"], ie = ["top", "bottom"], oe = ["bottom", "top"];
        switch (I) {
          case "top":
          case "bottom":
            return ne ? j ? Ft : Dt : j ? Dt : Ft;
          case "left":
          case "right":
            return j ? ie : oe;
          default:
            return [];
        }
      }(K(O), C === "start", R);
      return S && (P = P.map((I) => I + "-" + S), D && (P = P.concat(P.map(yt)))), P;
    }(l, f, h, w));
    const k = [l, ...x], b = await Tt(t, u), E = [];
    let L = ((o = i.flip) == null ? void 0 : o.overflows) || [];
    if (g && E.push(b[y]), m) {
      const O = function(D, C, R) {
        R === void 0 && (R = !1);
        const S = Z(D), P = Lt(D), I = St(P);
        let j = P === "x" ? S === (R ? "end" : "start") ? "right" : "left" : S === "start" ? "bottom" : "top";
        return C.reference[I] > C.floating[I] && (j = ct(j)), [j, ct(j)];
      }(s, a, w);
      E.push(b[O[0]], b[O[1]]);
    }
    if (L = [...L, { placement: s, overflows: E }], !E.every((O) => O <= 0)) {
      var $, _;
      const O = ((($ = i.flip) == null ? void 0 : $.index) || 0) + 1, D = k[O];
      if (D) return { data: { index: O, overflows: L }, reset: { placement: D } };
      let C = (_ = L.filter((R) => R.overflows[0] <= 0).sort((R, S) => R.overflows[1] - S.overflows[1])[0]) == null ? void 0 : _.placement;
      if (!C) switch (p) {
        case "bestFit": {
          var A;
          const R = (A = L.map((S) => [S.placement, S.overflows.filter((P) => P > 0).reduce((P, I) => P + I, 0)]).sort((S, P) => S[1] - P[1])[0]) == null ? void 0 : A[0];
          R && (C = R);
          break;
        }
        case "initialPlacement":
          C = l;
      }
      if (s !== C) return { reset: { placement: C } };
    }
    return {};
  } };
}, Ce = function(e) {
  return e === void 0 && (e = {}), { name: "size", options: e, async fn(t) {
    const { placement: n, rects: o, platform: s, elements: i } = t, { apply: a = () => {
    }, ...l } = et(e, t), r = await Tt(t, l), c = K(n), g = Z(n), m = st(n) === "y", { width: d, height: p } = o.floating;
    let h, f;
    c === "top" || c === "bottom" ? (h = c, f = g === (await (s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (f = c, h = g === "end" ? "top" : "bottom");
    const u = p - r[h], y = d - r[f], v = !t.middlewareData.shift;
    let w = u, x = y;
    if (m) {
      const b = d - r.left - r.right;
      x = g || v ? X(y, b) : b;
    } else {
      const b = p - r.top - r.bottom;
      w = g || v ? X(u, b) : b;
    }
    if (v && !g) {
      const b = B(r.left, 0), E = B(r.right, 0), L = B(r.top, 0), $ = B(r.bottom, 0);
      m ? x = d - 2 * (b !== 0 || E !== 0 ? b + E : B(r.left, r.right)) : w = p - 2 * (L !== 0 || $ !== 0 ? L + $ : B(r.top, r.bottom));
    }
    await a({ ...t, availableWidth: x, availableHeight: w });
    const k = await s.getDimensions(i.floating);
    return d !== k.width || p !== k.height ? { reset: { rects: !0 } } : {};
  } };
}, Re = (e) => ({ name: "arrow", options: e, async fn(t) {
  const { x: n, y: o, placement: s, rects: i, platform: a, elements: l, middlewareData: r } = t, { element: c, padding: g = 0 } = et(e, t) || {};
  if (c == null) return {};
  const m = Xt(g), d = { x: n, y: o }, p = Lt(s), h = St(p), f = await a.getDimensions(c), u = p === "y", y = u ? "top" : "left", v = u ? "bottom" : "right", w = u ? "clientHeight" : "clientWidth", x = i.reference[h] + i.reference[p] - d[p] - i.floating[h], k = d[p] - i.reference[p], b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
  let E = b ? b[w] : 0;
  E && await (a.isElement == null ? void 0 : a.isElement(b)) || (E = l.floating[w] || i.floating[h]);
  const L = x / 2 - k / 2, $ = E / 2 - f[h] / 2 - 1, _ = X(m[y], $), A = X(m[v], $), O = _, D = E - f[h] - A, C = E / 2 - f[h] / 2 + L, R = Ot(O, C, D), S = !r.arrow && Z(s) != null && C !== R && i.reference[h] / 2 - (C < O ? _ : A) - f[h] / 2 < 0, P = S ? C < O ? C - O : C - D : 0;
  return { [p]: d[p] + P, data: { [p]: R, centerOffset: C - R - P, ...S && { alignmentOffset: P } }, reset: S };
} }), Se = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), s = { platform: Pe, ...n }, i = { ...s.platform, _c: o };
  return (async (a, l, r) => {
    const { placement: c = "bottom", strategy: g = "absolute", middleware: m = [], platform: d } = r, p = m.filter(Boolean), h = await (d.isRTL == null ? void 0 : d.isRTL(l));
    let f = await d.getElementRects({ reference: a, floating: l, strategy: g }), { x: u, y } = qt(f, c, h), v = c, w = {}, x = 0;
    for (let k = 0; k < p.length; k++) {
      const { name: b, fn: E } = p[k], { x: L, y: $, data: _, reset: A } = await E({ x: u, y, initialPlacement: c, placement: v, strategy: g, middlewareData: w, rects: f, platform: d, elements: { reference: a, floating: l } });
      u = L ?? u, y = $ ?? y, w = { ...w, [b]: { ...w[b], ..._ } }, A && x <= 50 && (x++, typeof A == "object" && (A.placement && (v = A.placement), A.rects && (f = A.rects === !0 ? await d.getElementRects({ reference: a, floating: l, strategy: g }) : A.rects), { x: u, y } = qt(f, v, h)), k = -1);
    }
    return { x: u, y, placement: v, strategy: g, middlewareData: w };
  })(e, t, { ...s, platform: i });
};
function ht(e) {
  if (e === void 0) return 0;
  const t = window.devicePixelRatio || 1;
  return Math.round(e * t) / t;
}
const Le = (e) => {
  var t;
  return (t = { left: ["right", "bottom", "top"], "left-start": ["right-start", "bottom", "top"], "left-end": ["right-end", "bottom", "top"], right: ["left", "bottom", "top"], "right-start": ["left-start", "bottom", "top"], "right-end": ["left-end", "bottom", "top"], top: ["bottom", "left", "right"], "top-start": ["bottom-start", "left", "right"], "top-end": ["bottom-end", "left", "right"], bottom: ["top", "left", "right"], "bottom-start": ["top-start", "left", "right"], "bottom-end": ["top-end", "left", "right"] }[e]) != null ? t : [e];
};
class Te {
  constructor(t) {
    this.originalPlacements = /* @__PURE__ */ new WeakMap(), this.allowPlacementUpdate = !1, this.closeForAncestorUpdate = () => {
      !this.allowPlacementUpdate && this.options.type !== "modal" && this.cleanup && this.target.dispatchEvent(new Event("close", { bubbles: !0 })), this.allowPlacementUpdate = !1;
    }, this.updatePlacement = () => {
      this.computePlacement();
    }, this.resetOverlayPosition = () => {
      !this.target || !this.options || (this.clearOverlayPosition(), this.host.offsetHeight, this.computePlacement());
    }, this.host = t, this.host.addController(this);
  }
  async placeOverlay(t = this.target, n = this.options) {
    if (this.target = t, this.options = n, !t || !n) return;
    const o = Ut(n.trigger, t, this.closeForAncestorUpdate, { ancestorResize: !1, elementResize: !1, layoutShift: !1 }), s = Ut(n.trigger, t, this.updatePlacement, { ancestorScroll: !1 });
    this.cleanup = () => {
      var i;
      (i = this.host.elements) == null || i.forEach((a) => {
        a.addEventListener("sp-closed", () => {
          const l = this.originalPlacements.get(a);
          l && a.setAttribute("placement", l), this.originalPlacements.delete(a);
        }, { once: !0 });
      }), o(), s();
    };
  }
  async computePlacement() {
    var t, n;
    const { options: o, target: s } = this;
    await (document.fonts ? document.fonts.ready : Promise.resolve());
    const i = o.trigger instanceof HTMLElement ? zt() : zt({ padding: 8, fallbackPlacements: Le(o.placement) }), [a = 0, l = 0] = Array.isArray(o == null ? void 0 : o.offset) ? o.offset : [o.offset, 0], r = (t = this.host.elements.find((h) => h.tipElement)) == null ? void 0 : t.tipElement, c = [ve({ mainAxis: a, crossAxis: l }), Oe({ padding: 8 }), i, Ce({ padding: 8, apply: ({ availableWidth: h, availableHeight: f, rects: { floating: u } }) => {
      const y = Math.max(100, Math.floor(f)), v = u.height;
      this.initialHeight = this.isConstrained && this.initialHeight || v, this.isConstrained = v < this.initialHeight || y <= v;
      const w = this.isConstrained ? `${y}px` : "";
      Object.assign(s.style, { maxWidth: `${Math.floor(h)}px`, maxHeight: w });
    } }), ...r ? [Re({ element: r, padding: o.tipPadding || 8 })] : []], { x: g, y: m, placement: d, middlewareData: p } = await Se(o.trigger, s, { placement: o.placement, middleware: c, strategy: "fixed" });
    if (Object.assign(s.style, { top: "0px", left: "0px", translate: `${ht(g)}px ${ht(m)}px` }), s.setAttribute("actual-placement", d), (n = this.host.elements) == null || n.forEach((h) => {
      this.originalPlacements.has(h) || this.originalPlacements.set(h, h.getAttribute("placement")), h.setAttribute("placement", d);
    }), r && p.arrow) {
      const { x: h, y: f } = p.arrow;
      Object.assign(r.style, { top: d.startsWith("right") || d.startsWith("left") ? "0px" : "", left: d.startsWith("bottom") || d.startsWith("top") ? "0px" : "", translate: `${ht(h)}px ${ht(f)}px` });
    }
  }
  clearOverlayPosition() {
    this.target && (this.target.style.removeProperty("max-height"), this.target.style.removeProperty("max-width"), this.initialHeight = void 0, this.isConstrained = !1);
  }
  hostConnected() {
    document.addEventListener("sp-update-overlays", this.resetOverlayPosition);
  }
  hostUpdated() {
    var t;
    this.host.open || ((t = this.cleanup) == null || t.call(this), this.cleanup = void 0);
  }
  hostDisconnected() {
    var t;
    (t = this.cleanup) == null || t.call(this), this.cleanup = void 0, document.removeEventListener("sp-update-overlays", this.resetOverlayPosition);
  }
}
const ke = pe`
    :host{pointer-events:none;--swc-overlay-animation-distance:var(--spectrum-spacing-100);display:contents}:host(:has(>sp-tooltip)){--swc-overlay-animation-distance:var(--spectrum-tooltip-animation-distance)}.dialog{box-sizing:border-box;max-height:calc(100vh - 16px);max-height:calc(100dvh - 16px);max-width:calc(100vw - 16px);height:auto;--sp-overlay-open:true;background:0 0;border:0;margin:0;padding:0;display:flex;position:fixed;inset:0 auto auto 0;overflow:visible;opacity:1!important}.dialog:not([is-visible]){display:none}.dialog:focus{outline:none}dialog:modal{--mod-popover-filter:var(--spectrum-popover-filter)}:host(:not([open])) .dialog{--sp-overlay-open:false}.dialog::backdrop{display:none}.dialog:before{content:"";position:absolute;inset:-999em;pointer-events:auto!important}.dialog:not(.not-immediately-closable):before{display:none}.dialog>div{width:100%}::slotted(*){pointer-events:auto;visibility:visible!important}::slotted(sp-popover){position:static}.dialog:not([actual-placement])[placement*=top]{padding-block:var(--swc-overlay-animation-distance);margin-top:var(--swc-overlay-animation-distance)}.dialog:not([actual-placement])[placement*=right]{padding-inline:var(--swc-overlay-animation-distance);margin-left:calc(-1*var(--swc-overlay-animation-distance))}.dialog:not([actual-placement])[placement*=bottom]{padding-block:var(--swc-overlay-animation-distance);margin-top:calc(-1*var(--swc-overlay-animation-distance))}.dialog:not([actual-placement])[placement*=left]{padding-inline:var(--swc-overlay-animation-distance);margin-left:var(--swc-overlay-animation-distance)}.dialog[actual-placement*=top]{padding-block:var(--swc-overlay-animation-distance);margin-top:var(--swc-overlay-animation-distance)}.dialog[actual-placement*=right]{padding-inline:var(--swc-overlay-animation-distance);margin-left:calc(-1*var(--swc-overlay-animation-distance))}.dialog[actual-placement*=bottom]{padding-block:var(--swc-overlay-animation-distance);margin-top:calc(-1*var(--swc-overlay-animation-distance))}.dialog[actual-placement*=left]{padding-inline:var(--swc-overlay-animation-distance);margin-left:var(--swc-overlay-animation-distance)}slot[name=longpress-describedby-descriptor]{display:none}@supports selector(:open){.dialog{opacity:0}.dialog:open{opacity:1;--mod-popover-filter:var(--spectrum-popover-filter)}}@supports selector(:popover-open){.dialog{opacity:0}.dialog:popover-open{opacity:1;--mod-popover-filter:var(--spectrum-popover-filter)}}@supports (overlay:auto){.dialog{transition:all var(--mod-overlay-animation-duration,var(--spectrum-animation-duration-100,.13s)),translate 0s,display var(--mod-overlay-animation-duration,var(--spectrum-animation-duration-100,.13s));transition-behavior:allow-discrete;display:none}.dialog:popover-open,.dialog:modal{display:flex}}@supports (not selector(:open)) and (not selector(:popover-open)){:host:not([open]) .dialog{pointer-events:none}.dialog[actual-placement]{z-index:calc(var(--swc-overlay-z-index-base,1000) + var(--swc-overlay-open-count))}}
`;
var Ae = Object.defineProperty, De = Object.getOwnPropertyDescriptor, F = (e, t, n, o) => {
  for (var s, i = o > 1 ? void 0 : o ? De(t, n) : t, a = e.length - 1; a >= 0; a--) (s = e[a]) && (i = (o ? s(t, n, i) : s(i)) || i);
  return o && i && Ae(t, n, i), i;
};
const Fe = "showPopover" in document.createElement("div");
let nt = /* @__PURE__ */ function(e) {
  return class extends e {
    async manageDialogOpen() {
      const t = this.open;
      if (await M(), await this.managePosition(), this.open !== t) return;
      const n = await this.dialogMakeTransition(t);
      this.open === t && await this.dialogApplyFocus(t, n);
    }
    async dialogMakeTransition(t) {
      let n = null;
      const o = (i, a) => async () => {
        if (i.open = t, !t) {
          const r = () => {
            i.removeEventListener("close", r);
          };
          i.addEventListener("close", r);
        }
        if (a > 0) return;
        const l = t ? Pt : Et;
        this.dispatchEvent(new l()), t && (i.matches(xt) && (n = i), n = n || wt(i), n || i.querySelectorAll("slot").forEach((r) => {
          n || (n = bt(r));
        }), this.isConnected && !this.dialogEl.open && this.dialogEl.showModal());
      }, s = (i, a) => () => {
        if (this.open !== t) return;
        const l = t ? "sp-opened" : "sp-closed";
        if (a > 0) return void i.dispatchEvent(new W(l, this, { interaction: this.type, publish: !1 }));
        if (!this.isConnected || t !== this.open) return;
        const r = async () => {
          const c = this.triggerElement instanceof pt;
          this.dispatchEvent(new W(l, this, { interaction: this.type, publish: c })), i.dispatchEvent(new W(l, this, { interaction: this.type, publish: !1 })), this.triggerElement && !c && this.triggerElement.dispatchEvent(new W(l, this, { interaction: this.type, publish: !0 })), this.state = t ? "opened" : "closed", this.returnFocus(), await M(), await M(), t === this.open && t === !1 && this.requestSlottable();
        };
        !t && this.dialogEl.open ? (this.dialogEl.addEventListener("close", () => {
          r();
        }, { once: !0 }), this.dialogEl.close()) : r();
      };
      return this.elements.forEach((i, a) => {
        vt(i, o(i, a), s(i, a));
      }), n;
    }
    async dialogApplyFocus(t, n) {
      this.applyFocus(t, n);
    }
  };
}(jt);
var It;
Fe ? (It = nt, nt = class extends It {
  async manageDelay(e) {
    e !== !1 && e === this.open ? this.delayed && await at.openTimer(this) && (this.open = !e) : at.close(this);
  }
  async shouldHidePopover(e) {
    if (e && this.open !== e) return;
    const t = async ({ newState: n } = {}) => {
      n !== "open" && await this.placementController.resetOverlayPosition();
    };
    Ht(this.dialogEl) ? this.dialogEl.addEventListener("toggle", t, { once: !0 }) : t();
  }
  shouldShowPopover(e) {
    let t = !1;
    try {
      t = this.dialogEl.matches(":popover-open");
    } catch {
    }
    let n = !1;
    try {
      n = this.dialogEl.matches(":open");
    } catch {
    }
    e && this.open === e && !t && !n && this.isConnected && (this.dialogEl.showPopover(), this.managePosition());
  }
  async ensureOnDOM(e) {
    await M(), ge || await this.shouldHidePopover(e), this.shouldShowPopover(e), await M();
  }
  async makeTransition(e) {
    if (this.open !== e) return null;
    let t = null;
    const n = (s, i) => () => {
      if (s.open = e, i === 0) {
        const a = e ? Pt : Et;
        this.dispatchEvent(new a());
      }
      e && (s.matches(xt) && (t = s), t = t || wt(s), !t) && s.querySelectorAll("slot").forEach((a) => {
        t || (t = bt(a));
      });
    }, o = (s, i) => async () => {
      if (this.open !== e) return;
      const a = e ? "sp-opened" : "sp-closed";
      if (i > 0) return void s.dispatchEvent(new W(a, this, { interaction: this.type, publish: !1 }));
      const l = async () => {
        if (this.open !== e) return;
        await M();
        const c = this.triggerElement instanceof pt;
        this.dispatchEvent(new W(a, this, { interaction: this.type, publish: c })), s.dispatchEvent(new W(a, this, { interaction: this.type, publish: !1 })), this.triggerElement && !c && this.triggerElement.dispatchEvent(new W(a, this, { interaction: this.type, publish: !0 })), this.state = e ? "opened" : "closed", this.returnFocus(), await M(), await M(), e === this.open && e === !1 && this.requestSlottable();
      };
      if (this.open !== e) return;
      const r = Ht(this.dialogEl);
      e !== !0 && r && this.isConnected ? (this.dialogEl.addEventListener("beforetoggle", () => {
        l();
      }, { once: !0 }), this.dialogEl.hidePopover()) : l();
    };
    return this.elements.forEach((s, i) => {
      vt(s, n(s, i), o(s, i));
    }), t;
  }
}) : nt = /* @__PURE__ */ function(e) {
  return class extends e {
    async managePopoverOpen() {
      await this.managePosition();
    }
    async manageDelay(t) {
      t !== !1 && t === this.open ? this.delayed && await at.openTimer(this) && (this.open = !t) : at.close(this);
    }
    async ensureOnDOM(t) {
      document.body.offsetHeight;
    }
    async makeTransition(t) {
      if (this.open !== t) return null;
      let n = null;
      const o = (i, a) => () => {
        if (t === this.open) {
          if (i.open = t, a === 0) {
            const l = t ? Pt : Et;
            this.dispatchEvent(new l());
          }
          t !== !0 || (i.matches(xt) && (n = i), n = n || wt(i), n) || i.querySelectorAll("slot").forEach((l) => {
            n || (n = bt(l));
          });
        }
      }, s = (i, a) => async () => {
        if (this.open !== t) return;
        const l = t ? "sp-opened" : "sp-closed";
        if (i.dispatchEvent(new W(l, this, { interaction: this.type })), a > 0) return;
        const r = this.triggerElement instanceof pt;
        this.dispatchEvent(new W(l, this, { interaction: this.type, publish: r })), this.triggerElement && !r && this.triggerElement.dispatchEvent(new W(l, this, { interaction: this.type, publish: !0 })), this.state = t ? "opened" : "closed", this.returnFocus(), await M(), await M(), t === this.open && t === !1 && this.requestSlottable();
      };
      return this.elements.forEach((i, a) => {
        vt(i, o(i, a), s(i, a));
      }), n;
    }
  };
}(nt);
const T = class Rt extends nt {
  constructor() {
    super(...arguments), this._delayed = !1, this._disabled = !1, this.offset = 0, this._open = !1, this.lastRequestSlottableState = !1, this.receivesFocus = "auto", this._state = "closed", this.triggerElement = null, this.type = "auto", this.wasOpen = !1, this.closeOnFocusOut = (t) => {
      if (!t.relatedTarget) return;
      const n = new Event("overlay-relation-query", { bubbles: !0, composed: !0 });
      t.relatedTarget.addEventListener(n.type, (o) => {
        o.composedPath().includes(this) || (this.open = !1);
      }), t.relatedTarget.dispatchEvent(n);
    };
  }
  get delayed() {
    var t;
    return ((t = this.elements.at(-1)) == null ? void 0 : t.hasAttribute("delayed")) || this._delayed;
  }
  set delayed(t) {
    this._delayed = t;
  }
  get disabled() {
    return this._disabled;
  }
  set disabled(t) {
    var n;
    this._disabled = t, t ? ((n = this.strategy) == null || n.abort(), this.wasOpen = this.open, this.open = !1) : (this.bindEvents(), this.open = this.open || this.wasOpen, this.wasOpen = !1);
  }
  get hasNonVirtualTrigger() {
    return !(!this.triggerElement || this.triggerElement instanceof pt);
  }
  get placementController() {
    return this._placementController || (this._placementController = new Te(this)), this._placementController;
  }
  get open() {
    return this._open;
  }
  set open(t) {
    var n;
    t && this.disabled || t !== this.open && ((n = this.strategy) != null && n.activelyOpening && !t || (this._open = t, this.open && (Rt.openCount += 1), this.requestUpdate("open", !this.open), this.open && this.requestSlottable()));
  }
  get state() {
    return this._state;
  }
  set state(t) {
    var n;
    if (t === this.state) return;
    const o = this.state;
    this._state = t, (this.state === "opened" || this.state === "closed") && ((n = this.strategy) == null || n.shouldCompleteOpen()), this.requestUpdate("state", o);
  }
  get elementResolver() {
    return this._elementResolver || (this._elementResolver = new se(this)), this._elementResolver;
  }
  get usesDialog() {
    return this.type === "modal" || this.type === "page";
  }
  get popoverValue() {
    if ("popover" in this) switch (this.type) {
      case "modal":
      case "page":
        return;
      case "hint":
        return "manual";
      default:
        return this.type;
    }
  }
  get requiresPositioning() {
    return !(this.type === "page" || !this.open || !this.triggerElement || !this.placement && this.type !== "hint");
  }
  managePosition() {
    if (!this.requiresPositioning || !this.open) return;
    const t = this.offset || 0, n = this.triggerElement, o = this.placement || "right", s = this.tipPadding;
    this.placementController.placeOverlay(this.dialogEl, { offset: t, placement: o, tipPadding: s, trigger: n, type: this.type });
  }
  async managePopoverOpen() {
    super.managePopoverOpen();
    const t = this.open;
    if (this.open !== t || (await this.manageDelay(t), this.open !== t) || (await this.ensureOnDOM(t), this.open !== t)) return;
    const n = await this.makeTransition(t);
    this.open === t && await this.applyFocus(t, n);
  }
  async applyFocus(t, n) {
    if (this.receivesFocus !== "false" && this.type !== "hint") {
      if (await M(), await M(), t === this.open && !this.open) return void (this.hasNonVirtualTrigger && this.contains(this.getRootNode().activeElement) && this.triggerElement.focus());
      n == null || n.focus();
    }
  }
  returnFocus() {
    var t;
    this.open || this.type === "hint" || this.receivesFocus !== "false" && (t = this.triggerElement) != null && t.focus && (this.contains(this.getRootNode().activeElement) || (() => {
      var n, o;
      const s = [];
      let i = document.activeElement;
      for (; (n = i == null ? void 0 : i.shadowRoot) != null && n.activeElement; ) i = i.shadowRoot.activeElement;
      for (; i; ) {
        const a = i.assignedSlot || i.parentElement || ((o = i.getRootNode()) == null ? void 0 : o.host);
        a && s.push(a), i = a;
      }
      return s;
    })().includes(this) || document.activeElement === document.body) && this.triggerElement.focus();
  }
  async manageOpen(t) {
    if ((this.isConnected || !this.open) && (this.hasUpdated || await this.updateComplete, this.open ? (Mt.add(this), this.willPreventClose && (document.addEventListener("pointerup", () => {
      this.dialogEl.classList.toggle("not-immediately-closable", !1), this.willPreventClose = !1;
    }, { once: !0 }), this.dialogEl.classList.toggle("not-immediately-closable", !0))) : (t && this.dispose(), Mt.remove(this)), this.open && this.state !== "opened" ? this.state = "opening" : !this.open && this.state !== "closed" && (this.state = "closing"), this.usesDialog ? this.manageDialogOpen() : this.managePopoverOpen(), this.type === "auto")) {
      const n = this.getRootNode();
      this.open ? n.addEventListener("focusout", this.closeOnFocusOut, { capture: !0 }) : n.removeEventListener("focusout", this.closeOnFocusOut, { capture: !0 });
    }
  }
  bindEvents() {
    var t;
    (t = this.strategy) == null || t.abort(), this.strategy = void 0, this.hasNonVirtualTrigger && this.triggerInteraction && (this.strategy = new le[this.triggerInteraction](this.triggerElement, { overlay: this }));
  }
  handleBeforetoggle(t) {
    t.newState !== "open" && this.handleBrowserClose(t);
  }
  handleBrowserClose(t) {
    var n;
    t.stopPropagation(), (n = this.strategy) != null && n.activelyOpening ? this.manuallyKeepOpen() : this.open = !1;
  }
  manuallyKeepOpen() {
    this.open = !0, this.placementController.allowPlacementUpdate = !0, this.manageOpen(!1);
  }
  handleSlotchange() {
    var t, n;
    this.elements.length ? this.hasNonVirtualTrigger && ((n = this.strategy) == null || n.prepareDescription(this.triggerElement)) : (t = this.strategy) == null || t.releaseDescription();
  }
  shouldPreventClose() {
    const t = this.willPreventClose;
    return this.willPreventClose = !1, t;
  }
  requestSlottable() {
    this.lastRequestSlottableState !== this.open && (this.open || document.body.offsetHeight, this.dispatchEvent(new ce("overlay-content", this.open ? {} : he)), this.lastRequestSlottableState = this.open);
  }
  willUpdate(t) {
    var n;
    if (this.hasAttribute("id") || this.setAttribute("id", `${this.tagName.toLowerCase()}-${re()}`), t.has("open") && (this.hasUpdated || this.open) && this.manageOpen(t.get("open")), t.has("trigger")) {
      const [s, i] = ((n = this.trigger) == null ? void 0 : n.split("@")) || [];
      this.elementResolver.selector = s ? `#${s}` : "", this.triggerInteraction = i;
    }
    let o = !1;
    t.has(ae) && (o = this.triggerElement, this.triggerElement = this.elementResolver.element), t.has("triggerElement") && (o = t.get("triggerElement")), o !== !1 && this.bindEvents();
  }
  updated(t) {
    super.updated(t), t.has("placement") && (this.placement ? this.dialogEl.setAttribute("actual-placement", this.placement) : this.dialogEl.removeAttribute("actual-placement"), this.open && t.get("placement") !== void 0 && this.placementController.resetOverlayPosition()), t.has("state") && this.state === "closed" && t.get("state") !== void 0 && this.placementController.clearOverlayPosition();
  }
  renderContent() {
    return rt`
            <slot @slotchange=${this.handleSlotchange}></slot>
        `;
  }
  get dialogStyleMap() {
    return { "--swc-overlay-open-count": Rt.openCount.toString() };
  }
  renderDialog() {
    return rt`
            <dialog
                class="dialog"
                part="dialog"
                placement=${mt(this.requiresPositioning ? this.placement || "right" : void 0)}
                style=${Bt(this.dialogStyleMap)}
                @close=${this.handleBrowserClose}
                @cancel=${this.handleBrowserClose}
                @beforetoggle=${this.handleBeforetoggle}
                ?is-visible=${this.state !== "closed"}
            >
                ${this.renderContent()}
            </dialog>
        `;
  }
  renderPopover() {
    return rt`
            <div
                class="dialog"
                part="dialog"
                placement=${mt(this.requiresPositioning ? this.placement || "right" : void 0)}
                popover=${mt(this.popoverValue)}
                style=${Bt(this.dialogStyleMap)}
                @beforetoggle=${this.handleBeforetoggle}
                @close=${this.handleBrowserClose}
                ?is-visible=${this.state !== "closed"}
            >
                ${this.renderContent()}
            </div>
        `;
  }
  render() {
    const t = this.type === "modal" || this.type === "page";
    return rt`
            ${t ? this.renderDialog() : this.renderPopover()}
            <slot name="longpress-describedby-descriptor"></slot>
        `;
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("close", () => {
      this.open = !1;
    }), this.hasUpdated && this.bindEvents();
  }
  disconnectedCallback() {
    var t;
    (t = this.strategy) == null || t.releaseDescription(), this.open = !1, super.disconnectedCallback();
  }
};
T.styles = [ke], T.openCount = 1, F([N({ type: Boolean })], T.prototype, "delayed", 1), F([$t(".dialog")], T.prototype, "dialogEl", 2), F([N({ type: Boolean })], T.prototype, "disabled", 1), F([de({ flatten: !0, selector: ':not([slot="longpress-describedby-descriptor"], slot)' })], T.prototype, "elements", 2), F([N({ type: Number })], T.prototype, "offset", 2), F([N({ type: Boolean, reflect: !0 })], T.prototype, "open", 1), F([N()], T.prototype, "placement", 2), F([N({ attribute: "receives-focus" })], T.prototype, "receivesFocus", 2), F([$t("slot")], T.prototype, "slotEl", 2), F([ue()], T.prototype, "state", 1), F([N({ type: Number, attribute: "tip-padding" })], T.prototype, "tipPadding", 2), F([N()], T.prototype, "trigger", 2), F([N({ attribute: !1 })], T.prototype, "triggerElement", 2), F([N({ attribute: !1 })], T.prototype, "triggerInteraction", 2), F([N()], T.prototype, "type", 2);
let Ke = T;
export {
  Ge as LONGPRESS_INSTRUCTIONS,
  Ke as Overlay
};
//# sourceMappingURL=Overlay-DvOyF6kR.js.map
